import { csrfTokenHeader } from "@circle-react/helpers/csrfToken";
import { safeJsonParse } from "@circle-react/helpers/safeJsonParse";
import { useBoolean } from "@circle-react/hooks/utils/useBoolean";
import { fetchEventSource } from "@microsoft/fetch-event-source";

export const useEditionsStream = () => {
  const [isLoading, toggleIsLoading] = useBoolean(false);

  const createEdition = async ({
    type,
    selected_text = "",
    user_prompt,
    onOpen,
    onMessage,
    onClose,
    onError,
  }) => {
    toggleIsLoading(true);
    await fetchEventSource("/internal_api/copilot/editions", {
      method: "POST",
      body: JSON.stringify({
        context: {
          selected_text,
          type,
          user_prompt,
        },
      }),
      headers: {
        Accept: "text/event-stream",
        "Content-Type": "application/json",
        ...csrfTokenHeader(),
      },
      onopen(res) {
        if (res.ok && res.status === 200) {
          onOpen();
        } else if (
          res.status >= 400 &&
          res.status < 500 &&
          res.status !== 429
        ) {
          toggleIsLoading(false);
          onError?.();
        }
      },
      onmessage(event) {
        const parsedData = safeJsonParse(event.data);
        if (parsedData?.content) {
          onMessage(parsedData.content);
        }
      },
      onclose() {
        toggleIsLoading(false);
        onClose();
      },
      onerror() {
        toggleIsLoading(false);
        onError?.();
      },
    });
  };

  return { createEdition, isLoading };
};
